import { motion } from 'framer-motion';

interface PauseOverlayProps {
  isPaused: boolean;
}

export function PauseOverlay({ isPaused }: PauseOverlayProps) {
  if (!isPaused) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="absolute inset-0 bg-slate-950/60 backdrop-blur-md flex items-center justify-center z-50 pointer-events-auto"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 25 }}
        className="glass rounded-3xl p-8 max-w-sm w-full mx-4 border border-amber-500/20 text-center shadow-glow-lg select-none"
      >
        <span className="text-4xl filter drop-shadow-md animate-pulse">⏸</span>
        <h2 className="font-display text-2xl font-black text-amber-300 uppercase tracking-widest mt-4 mb-2">
          Game Paused
        </h2>
        <p className="text-surface-400 text-xs font-semibold uppercase tracking-wider leading-relaxed">
          Waiting for Host to resume...
        </p>
      </motion.div>
    </motion.div>
  );
}
